/**
 * LoggedIn form component.
 *
 * @returns {JSX.Element}
 */
// State action for update/set rule config.
import {useDispatch} from 'react-redux';
import {setRuleConfig} from "@app/modules/PersonaForm/store/PersonaFormStore";
import {useEffect} from "react";

export default function Returning3() {

	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(setRuleConfig(
			{
				id: 'Returning3',
				config: {
					ruleType: "returning_visitor",
					args: {
						visit_count: 3
					}
				}
			}
		));
	}, []);

	return <>
		<p>
			This
			rule
			targets
			returning
			users
			visiting
			your
			website
			for
			the
			third
			time.
		</p>
	</>;
}
